export default __webpack_public_path__ + "static/media/Auto_1.c71b7153.JPG";